import { createActionCreator } from '@pressreader/appstore';

import { MODULE_NAME } from '../../constants';
import { Comment } from '../../types/comment';

const prefix = `${MODULE_NAME}/commoon/`;

export const initialLoadBegan = createActionCreator<{
    articleId: string;
}>(`${prefix}initial-load-began`);

export const initialLoadDone = createActionCreator<{
    comments: Comment[];
    offset: number;
    totalCommentsCount: number;
    rootCommentsCount: number;
}>(`${prefix}initial-load-done`);

export const initialLoadFailed = createActionCreator(`${prefix}initial-load-failed`);

export const followUserAction = createActionCreator<{
    userProfileName: string;
}>(`${prefix}follow-user`);
export const followUserDone = createActionCreator<{ userProfileName: string }>(`${prefix}follow-user-done`);

export const unfollowUserAction = createActionCreator<{ userProfileName: string }>(`${prefix}unfollow-user`);
export const unfollowUserDone = createActionCreator<{ userProfileName: string }>(`${prefix}unfollow-user-done`);

export const openUserProfileAction = createActionCreator<{ userProfileName: string }>(`${prefix}open-user-profile`);

export const commentsDialogOpening = createActionCreator<{ articleId: string }>(`${prefix}comments-dialog-opening`);

export const commentsDialogOpened = createActionCreator<{ popupId: string }>(`${prefix}comments-dialog-opened`);

export const commentsDialogClosing = createActionCreator<{ popupId: string }>(`${prefix}comments-dialog-closing`);

export const commentsDialogClosed = createActionCreator<{ popupId: string }>(`${prefix}comments-dialog-closed`);
